import { Label } from "@/components/ui/label";
import { LAYOUT_PRESETS } from "@/lib/presets";
import type { LayoutConfig, Playlist } from "@/lib/types";
import { PlaylistSelect } from "@/components/app/ConfigEditor";

export function LayoutMini({ type, active }: { type: string; active?: boolean }) {
  const preset = LAYOUT_PRESETS.find((p) => p.v === type) || LAYOUT_PRESETS[0];
  return (
    <span className="relative block aspect-video w-full overflow-hidden rounded-sm border border-slate-600">
      {preset.zones.map((z, i) => (
        <span key={z.id} className={`absolute border border-slate-950 ${i === 0 ? (active ? "bg-orange-500/70" : "bg-slate-500") : active ? "bg-orange-300/40" : "bg-slate-700"}`}
          style={{ left: `${z.x * 100}%`, top: `${z.y * 100}%`, width: `${z.w * 100}%`, height: `${z.h * 100}%` }} />
      ))}
    </span>
  );
}

export function LayoutEditor({ value, onChange, playlists, disabled }: { value?: LayoutConfig; onChange: (l: LayoutConfig) => void; playlists: Playlist[]; disabled?: boolean }) {
  const layout = value || { type: "full", zones: {} };
  const preset = LAYOUT_PRESETS.find((p) => p.v === layout.type) || LAYOUT_PRESETS[0];
  return (
    <div className="space-y-4" data-testid="layout-editor">
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-4 lg:grid-cols-7">
        {LAYOUT_PRESETS.map((p) => {
          const active = p.v === layout.type;
          return (
            <button key={p.v} type="button" disabled={disabled} data-testid={`layout-${p.v}`} onClick={() => onChange({ type: p.v, zones: layout.zones })}
              className={`flex flex-col gap-2 rounded-lg border p-2 text-left text-[11px] transition-colors disabled:opacity-60 ${active ? "border-orange-500/60 bg-orange-500/10 text-orange-200" : "border-slate-700 text-slate-400 hover:text-slate-200"}`}>
              <LayoutMini type={p.v} active={active} />{p.label}
            </button>
          );
        })}
      </div>
      {preset.zones.length > 1 && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-lg border border-slate-800 bg-slate-950/40 p-3"><Label className="eyebrow">{preset.zones[0].label}</Label><p className="mt-2 text-xs text-slate-400">Liste par défaut et plages planifiées ci-dessous.</p></div>
          {preset.zones.slice(1).map((z) => (
            <div key={z.id} className="space-y-2 rounded-lg border border-slate-800 bg-slate-950/40 p-3">
              <Label className="eyebrow">{z.label}</Label>
              <PlaylistSelect value={layout.zones[z.id] || null} onChange={(v) => onChange({ ...layout, zones: { ...layout.zones, [z.id]: v } })} playlists={playlists} testId={`layout-zone-${z.id}-playlist`} disabled={disabled} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
